import { cn } from '@shared/lib/cn';

import {
  TABLE_CELL_ALIGN_CLASS,
  TABLE_COLUMN_GROW_CLASS,
  TABLE_COLUMN_WIDTH_CLASS,
  type TableCellAlign,
  type TableColumnGrow,
  type TableColumnWidth,
} from './table.constant';

export interface TableCellShapeInput {
  width?: TableColumnWidth;
  grow?: TableColumnGrow;
  align?: TableCellAlign;
}

/** 칸 너비 · 비율 · 정렬 → 클래스. `TableCell` 과 스켈레톤이 함께 쓴다 */
export function tableCellShapeClass({
  width = 'fill',
  grow,
  align = 'start',
}: TableCellShapeInput) {
  return cn(
    TABLE_COLUMN_WIDTH_CLASS[width],
    width === 'fill' && TABLE_COLUMN_GROW_CLASS[grow ?? 1],
    TABLE_CELL_ALIGN_CLASS[align],
  );
}
